import clsx from "clsx";
import React from "react";
import { Button } from "../catalyst/button";

interface BottomActionButtonProps {
  /** 버튼에 표시될 텍스트 */
  children: React.ReactNode;
  /** 버튼 클릭 핸들러 */
  onClick: () => void;
  /** 로딩 상태 */
  isLoading?: boolean;
  /** 로딩 시 표시될 텍스트 */
  loadingText?: string;
  /** 버튼 비활성화 상태 */
  disabled?: boolean;
  /** 추가 CSS 클래스 */
  className?: string;
}

const BottomActionButton: React.FC<BottomActionButtonProps> = ({
  children,
  onClick,
  isLoading = false,
  loadingText = "처리 중...",
  disabled = false,
  className = "",
}) => {
  const isDisabled = isLoading || disabled;
  const displayText = isLoading ? loadingText : children;

  return (
    <>
      {/* 데스크톱용 하단 버튼 영역 */}
      <div className="hidden md:block flex-shrink-0 px-4 py-4 bg-white border-t border-border-default">
        <Button
          onClick={onClick}
          disabled={isDisabled}
          color="blue"
          className={clsx("w-full py-4 text-base", className)}
        >
          {displayText}
        </Button>
      </div>

      {/* 모바일용 하단 고정 버튼 영역 */}
      <div
        className="md:hidden fixed bottom-0 left-0 right-0 px-4 pt-4 bg-white border-t border-border-default z-50"
        style={{
          paddingBottom:
            "max(1rem, calc(env(safe-area-inset-bottom) + 0.5rem))",
        }}
      >
        <Button
          onClick={onClick}
          disabled={isDisabled}
          color="blue"
          className={clsx("w-full py-4 text-base", className)}
        >
          {displayText}
        </Button>
      </div>
    </>
  );
};

export default BottomActionButton;
